import { TCountry, TError } from '@onesource/schemas';
import { useQuery } from '@tanstack/react-query';

import axios from '../../members/axios';

export const getCountryByIdQueryKey = (id: number | undefined) => ['geography', 'countries', id] as const;

export const useGetCountryByIdQuery = (id: number | undefined) =>
  useQuery<TCountry, TError>({
    queryKey: getCountryByIdQueryKey(id),
    queryFn: async () => {
      const { data } = await axios.get<TCountry>(`geography/countries/${id}`);
      return data;
    },
    enabled: !!id,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
